import { create } from 'zustand';
import { SiteSettings } from '../types';

const emptySettings: SiteSettings = { email: '', whatsappNumber: '', phoneNumbers: [] };

interface SettingsState {
  settings: SiteSettings;
  fetchSettings: () => Promise<void>;
}

export const useSettingsStore = create<SettingsState>()(set => ({
  settings: emptySettings,
  fetchSettings: async () => {
    try {
      const res = await fetch('/settings.json');
      if (!res.ok) throw new Error(`Failed to load settings: ${res.status}`);
      const settings = (await res.json()) as SiteSettings;
      set({ settings });
    } catch {
      set({ settings: emptySettings });
    }
  },
}));
